import Highlight from './Highlight';

export default Highlight;
